import { useCallback, useState } from 'react';
import { type ShareContent } from '@/utils/share';

export interface UseShareDialogReturn {
  isOpen: boolean;
  content: ShareContent | null;
  openShareDialog: (content: ShareContent) => void;
  closeShareDialog: () => void;
  setOpen: (open: boolean) => void;
}

/**
 * Hook to manage share dialog state
 */
export function useShareDialog(): UseShareDialogReturn {
  const [isOpen, setIsOpen] = useState(false);
  const [content, setContent] = useState<ShareContent | null>(null);

  const openShareDialog = useCallback((shareContent: ShareContent) => {
    setContent(shareContent);
    setIsOpen(true);
  }, []);

  const closeShareDialog = useCallback(() => {
    setIsOpen(false);
    // Clear content after animation completes
    setTimeout(() => setContent(null), 200);
  }, []);

  return {
    isOpen,
    content,
    openShareDialog,
    closeShareDialog,
    setOpen: setIsOpen,
  };
}
